// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import Utils from './utils'
import ajax from './api/ajax'

import axios from 'axios'
import VueAxios from 'vue-axios'

Vue.use(VueAxios, axios);
Vue.prototype.$axios = axios;

Vue.config.productionTip = false
require('normalize.css')
require('./themes/myy.mat.scss')
import install from './vue-install'
install(Vue)
ajax(Vue)


router.beforeEach((to, from, next) => {
    switch (to.name) {
        case 'Tel'://首页
            _vds.push(['setPageGroup', 'MyyHome'])
            break;
        case 'List'://列表页
            switch (to.params['type']) {
                case '0':
                    _vds.push(['setPageGroup', 'MyyCaseList']);
                    break;
                case '1':
                    _vds.push(['setPageGroup', 'MyyNewsList']);
                    break;
            }
            break;
        case 'Detail'://详情页

            break;
    }
    next()
})

// 处理移动端点击事件，解决300毫秒延时
import FastClick from 'fastclick';
FastClick.attach(document.body)
/* eslint-disable no-new */
var mainVuew=new Vue({
    el: '#app',
    router,
    template: '<App/>',
    components: {App},
    mounted() {
        Utils.rem()
    }
});



// WEBPACK FOOTER //
// ./src/main.js